import { IAppState } from 'spw-redux/reducer';
import { createSelector } from 'reselect';
import _ from 'lodash';

export const selectProjectSpaceTypes = (state: IAppState) =>
  state.spaceTypesReducer.spaceTypes;

export const selectIsFetchingSpaceTypes = (state: IAppState) =>
  state.spaceTypesReducer.isFetchingSpaceTypes;

export const selectProjectSpaceTypesAsMap = createSelector(
  selectProjectSpaceTypes,
  (projectSpaceTypes) => _.keyBy(projectSpaceTypes, 'id')
);

export const selectProjectSpaceTypesAsMapBySpaceTypeId = createSelector(
  selectProjectSpaceTypes,
  (projectSpaceTypes) =>
    projectSpaceTypes.reduce(
      (acc, projectSpaceType) => ({
        ...acc,
        [projectSpaceType.spaceType.id]: projectSpaceType,
      }),
      {}
    )
);

export const selectClientFacingNamesAreVisible = (state: IAppState) =>
  state.spaceTypesReducer.clientFacingNamesAreVisible;

export const selectCurrentSpaceTypeColors = (state: IAppState) =>
  state.spaceTypesReducer.currentSpaceTypeColors;
